import { SelectionMenuOption } from '~/components/Selections/SelectionMenu'
import StandardUniselection from '~/components/Selections/StandardUniselection'

import { TimeSelectStructure } from '../styles'

type TimeSelectProps = {
  times: SelectionMenuOption[]
  time: SelectionMenuOption
  setTime: (selected: SelectionMenuOption) => void
}

const TimeSelect = ({ times, time, setTime }: TimeSelectProps) => (
  <TimeSelectStructure>
    <StandardUniselection
      options={times}
      selectedOption={time}
      onSelect={(selected) => {
        setTime(selected as SelectionMenuOption)
      }}
      heightClass='regular'
    />
  </TimeSelectStructure>
)

export default TimeSelect
